import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo, useState } from 'react'

import { startMfaSetupEvent } from '@root/features/auth/setup-otp/atoms'
import {
  settingScreenAction,
  settingScreenAtom,
  SettingScreenPolicies,
} from '@root/features/settings/settings-screen/atoms'
import { useWarmPolicyIframes } from '@root/features/settings/settings-screen/hooks/use-warm-policy-iframes'
import { SETTINGS_HEADER_MAP } from '@root/features/settings/settings-screen/model'
import { SettingsView } from '@root/features/settings/settings-screen/ui/settings-view'
import { environmentAtom } from '@root/shared'
import { useTranslation } from '@root/shared/localization'
import { Dialog } from '@root/shared/ui-kit'

import { SettingsModalContent } from './settings-modal-content'
import { SettingsModalHeader } from './settings-modal-header'

import type { SetupOtpMode } from '@root/features/auth/setup-otp/ui'

export const SettingsModal: React.FC = () => {
  const [env] = useAtom(environmentAtom)
  const { t } = useTranslation()
  const [optMode, setOptMode] = useState<SetupOtpMode>('instructions')
  const [screen, setSettingScreen] = useAtom(settingScreenAtom)
  const settingScreen = useAction(settingScreenAction)

  const open = screen !== undefined

  useWarmPolicyIframes(env.policiesHost, open)

  const [headerTitle, returnHandler] = useMemo(
    () =>
      SETTINGS_HEADER_MAP({
        screen,
        optMode,
        setOptMode,
        setScreen: (screen) => settingScreen(screen),
      }),
    [screen, optMode, setOptMode, settingScreen],
  )

  startMfaSetupEvent.onCall(() => settingScreen('setup-otp'))

  return (
    <Dialog
      describedBy={t('settings')}
      open={open}
      onOpenChange={(open) => {
        if (!open) {
          setSettingScreen(undefined)
        }
      }}
    >
      <SettingsModalContent
        size={screen && SettingScreenPolicies.includes(screen) ? 'm' : 's'}
        header={
          <SettingsModalHeader title={t(headerTitle)} onBack={returnHandler} />
        }
      >
        <SettingsView
          screen={screen}
          optMode={optMode}
          setOptMode={setOptMode}
          setScreen={(screen) => settingScreen(screen)}
        />
      </SettingsModalContent>
    </Dialog>
  )
}
